import { FaExternalLinkAlt } from "react-icons/fa";
import ajharnatradeint from "../../Assets/Photos/WEB-Portfolio/ajharnatradeint.png";
import SB from "../../Assets/Photos/WEB-Portfolio/sultana-boutique.png";
import GS from "../../Assets/Photos/WEB-Portfolio/giftshare.png";
import AG from "../../Assets/Photos/WEB-Portfolio/AluminumGlass.jpg";
import GB from "../../Assets/Photos/WEB-Portfolio/gab-builder.png";

const projects = [
  {
    title: "Aluminum Glass & UPVC Work",
    description:
      "Aluminum Glass & UPVC Work is a trusted and experienced aluminum, glass, and UPVC service provider based in Qatar. Our skilled team delivers elegant, modern, and long-lasting solutions for both homes and commercial spaces. Whether it’s a door, window, shower partition or a complete shopfront, we serve with professionalism and care.",
    image: AG,
    link: "https://www.aluglassupvc.com/",
    showLink: true,
    tags: ["UI/UX", "DEVELOPMENT", "HOSTING"],
    reverse: true,
  },
  {
    title: "Gab Builders",
    description:
      "Gab Builders provide a comprehensive range of construction and specialist services designed to bring your vision to life with quality and precision.",
    image: GB,
    link: "https://www.gab-builders.com",
    showLink: true,
    tags: ["UI/UX", "DEVELOPMENT", "HOSTING"],
    reverse: false,
  },
  {
    title: "A JHARNA TRADE INTERNATIONAL",
    description:
      "A Jharna Trade International is a Human Resource Management Solution Organization that provides manpower across the world as requirements.",
    image: ajharnatradeint,
    link: "https://ajharnatradeint.com/",
    showLink: true,
    tags: ["CORPORATE", "RECRUITMENT", "WEB HOSTING"],
    reverse: true,
  },
  {
    title: "Sultana Boutique",
    description:
      "Sultana Boutique is an E-commerce site. We are passionate about helping you discover unique and elegant pieces that reflect your individuality and enhance your wardrobe.",
    image: SB,
    link: "https://sultanaboutiques.com/",
    showLink: false,
    tags: ["UI/UX", "DEVELOPMENT", "HOSTING"],
    reverse: false,
  },
  {
    title: "Gift Share",
    description:
      "Giftshare is an E-commerce site, Giftshare Chocolate, where sweet dreams are crafted into delectable reality.",
    image: GS,
    link: "https://giftshare.co.jp/",
    showLink: false,
    tags: ["UI DESIGN", "E-COMMERCE", "SEO"],
    reverse: true,
  },
];

const WebDev = () => {
  return (
    <div>
      {projects.map((project, idx) => (
        <div key={idx} className="hero bg-base-200 my-4">
          <div
            className={`hero-content flex-col m-5 ${
              project.reverse ? "lg:flex-row-reverse" : "lg:flex-row"
            }`}
          >
            <img
              src={project.image}
              alt={project.title}
              className="lg:w-1/2 rounded-lg shadow-2xl"
            />
            <div className={project.reverse ? "lg:pr-5" : "lg:pl-5"}>
              <div className="lg:flex flex-wrap gap-3 my-5 text-xs text-center">
                {project.tags.map((tag, tagIndex) => (
                  <p
                    key={tagIndex}
                    className="rounded-full bg-base-100 p-3 text-gray-400"
                  >
                    {tag}
                  </p>
                ))}
              </div>
              <h1 className="text-2xl font-bold uppercase">{project.title}</h1>
              <p className="py-6 text-justify text-gray-400">
                {project.description}
              </p>
              {project.showLink && (
                <a
                  href={project.link}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="flex items-center gap-x-2"
                >
                  <FaExternalLinkAlt />
                  <p className="font-semibold uppercase">Visit</p>
                </a>
              )}
            </div>
          </div>
        </div>
      ))}
    </div>
  );
};

export default WebDev;
